/* Autoplay in view, pause out of view, resume on return.

   The ported video and testimonial sections render <video autoplay>, which
   starts downloading and playing on page load whether or not anyone scrolls
   that far. Their Liquid swaps the autoplay attribute for data-rf-autoplay and
   preload="none", and this takes over: a clip starts (muted) once half of it is
   on screen, pauses as soon as it leaves, and starts again when it comes back.

   If the visitor pauses a clip themselves, it stays paused — scrolling away
   and back will not restart something they chose to stop. */
(function () {
  if (window.__rfAutoplayInView) return;
  window.__rfAutoplayInView = true;

  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function setup(video) {
    if (video.dataset.rfAutoplayReady) return;
    video.dataset.rfAutoplayReady = 'true';
    video.muted = true;

    /* play and pause events fire a task AFTER the call that caused them, so a
       flag cleared right after video.pause() is already gone when the event
       lands — which made every scroll-away look like the visitor pausing, and
       the clip then refused to resume. Count the calls we make instead, and
       let each event consume one. */
    let ownPauses = 0;
    let ownPlays = 0;

    video.addEventListener('pause', () => {
      if (ownPauses > 0) {
        ownPauses--;
        return;
      }
      if (!video.ended) video.dataset.rfUserPaused = 'true';
    });
    video.addEventListener('play', () => {
      if (ownPlays > 0) {
        ownPlays--;
        return;
      }
      delete video.dataset.rfUserPaused;
    });

    /* Clips without controls still need a way to start and stop. */
    if (!video.controls) {
      video.style.cursor = 'pointer';
      video.addEventListener('click', () => (video.paused ? video.play() : video.pause()));
    }

    if (reduce.matches || !('IntersectionObserver' in window)) return;

    new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            if (video.dataset.rfUserPaused || !video.paused) return;
            ownPlays++;
            const p = video.play();
            /* refused (autoplay policy) — no play event will come to consume it */
            if (p && p.catch) p.catch(() => (ownPlays = Math.max(0, ownPlays - 1)));
          } else if (!video.paused) {
            ownPauses++;
            video.pause();
          }
        });
      },
      { threshold: 0.5 }
    ).observe(video);
  }

  function scan(root) {
    (root || document).querySelectorAll('video[data-rf-autoplay]').forEach(setup);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan());
  else scan();

  /* Theme editor re-renders sections in place. */
  document.addEventListener('shopify:section:load', (e) => scan(e.target));
})();

/* Click-to-play testimonial clips: once a visitor starts one (with sound),
   pause it when it scrolls out of view or another clip starts. They don't
   resume on their own — the visitor pressed play, so they press it again. */
(function () {
  if (!('IntersectionObserver' in window)) return;
  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((e) => {
        if (!e.isIntersecting && !e.target.paused) e.target.pause();
      });
    },
    { threshold: 0.25 }
  );
  document.addEventListener(
    'play',
    (e) => {
      const v = e.target;
      if (!(v instanceof HTMLVideoElement) || !v.closest('.tm-card') || v.hasAttribute('data-rf-autoplay')) return;
      io.observe(v);
      document.querySelectorAll('.tm-card video').forEach((other) => {
        if (other !== v && !other.paused && !other.hasAttribute('data-rf-autoplay')) other.pause();
      });
    },
    true
  );
})();
